/**
 * From/To 통합 옵션
 * - 슬라이더에서 단일 스케일로 사용
 * - 첫 번째 옵션은 "전체" (to의 최대값)
 * - 나머지는 값이 큰 순서대로 정렬
 */

// =========================
// 년식 (Year)
// =========================
export const AptYearFromToOptions = {
  defaultFrom: 200, // 1년
  defaultTo: -10, // 전체
  options: [
    { label: "전체", value: 200 },
    { label: "40년", value: 40 },
    { label: "30년", value: 30 },
    { label: "25년", value: 25 },
    { label: "20년", value: 20 },
    { label: "15년", value: 15 },
    { label: "10년", value: 10 },
    { label: "7년", value: 7 },
    { label: "5년", value: 5 },
    { label: "3년", value: 3 },
    { label: "2년", value: 2 },
    { label: "1년", value: 1 },
    { label: "현재", value: -10 },
  ],
};

// =========================
// 세대수 (Household)
// =========================
export const AptHouseholdFromToOptions = {
  defaultFrom: 100, // 100세대
  defaultTo: 100000, // 전체
  options: [
    { label: "전체", value: 100000 },
    { label: "2000세대", value: 2000 },
    { label: "1500세대", value: 1500 },
    { label: "1000세대", value: 1000 },
    { label: "700세대", value: 700 },
    { label: "500세대", value: 500 },
    { label: "300세대", value: 300 },
    { label: "200세대", value: 200 },
    { label: "100세대", value: 100 },
  ],
};

// =========================
// 평형 (Pyeong)
// =========================
export const AptPyeongFromToOptions = {
  defaultFrom: 0, // 전체
  defaultTo: 10000, // 전체
  options: [
    { label: "전체", value: 10000 },
    ...Array.from({ length: 70 }, (_, index) => {
      const value = 70 - index;
      return { label: `${value}평`, value, quickSelect: value % 10 === 0 };
    }),
    { label: "전체", value: 0 },
  ],
};

// =========================
// 시세 (Deal Price)
// =========================
export const AptDealPriceFromToOptions = {
  defaultFrom: 0, // 전체
  defaultTo: 5000000, // 전체
  options: [
    { label: "전체", value: 5000000 },
    { label: "100억", value: 1000000 },
    { label: "50억", value: 500000 },
    { label: "30억", value: 300000 },
    { label: "20억", value: 200000 },
    { label: "15억", value: 150000 },
    { label: "10억", value: 100000 },
    { label: "7억", value: 70000 },
    { label: "5억", value: 50000 },
    { label: "3억", value: 30000 },
    { label: "2억", value: 20000 },
    { label: "1억", value: 10000 },
    { label: "5천만", value: 5000 },
    { label: "3천만", value: 3000 },
    { label: "전체", value: 0 },
  ],
};

// =========================
// 평당가 (Deal Price Per Space)
// =========================
export const AptDealPricePerSpaceFromToOptions = {
  defaultFrom: 0, // 전체
  defaultTo: 1000000, // 전체
  options: [
    { label: "전체", value: 1000000 },
    { label: "3억", value: 30000 },
    { label: "2억", value: 20000 },
    { label: "1억5천", value: 15000 },
    { label: "1억", value: 10000 },
    { label: "9천만", value: 9000 },
    { label: "8천만", value: 8000 },
    { label: "7천만", value: 7000 },
    { label: "6천만", value: 6000 },
    { label: "5천만", value: 5000 },
    { label: "4천만", value: 4000 },
    { label: "3천만", value: 3000 },
    { label: "2천만", value: 2000 },
    { label: "1천만", value: 1000 },
    { label: "700만", value: 700 },
    { label: "500만", value: 500 },
    { label: "300만", value: 300 },
    { label: "전체", value: 0 },
  ],
};

// =========================
// 전세가율 (Lease Price Ratio)
// =========================
export const AptLeasePriceRatioFromToOptions = {
  defaultFrom: 0, // 전체
  defaultTo: 100, // 전체
  options: [
    { label: "전체", value: 100 },
    { label: "90%", value: 90 },
    { label: "80%", value: 80 },
    { label: "70%", value: 70 },
    { label: "60%", value: 60 },
    { label: "50%", value: 50 },
    { label: "40%", value: 40 },
    { label: "30%", value: 30 },
    { label: "20%", value: 20 },
    { label: "10%", value: 10 },
    { label: "전체", value: 0 },
  ],
};

// =========================
// 매전갭 (Gap)
// =========================
export const AptGapFromToOptions = {
  defaultFrom: 0, // 전체
  defaultTo: 10000000, // 전체
  options: [
    { label: "전체", value: 10000000 },
    { label: "50억", value: 500000 },
    { label: "30억", value: 300000 },
    { label: "20억", value: 200000 },
    { label: "15억", value: 150000 },
    { label: "10억", value: 100000 },
    { label: "7억", value: 70000 },
    { label: "5억", value: 50000 },
    { label: "3억", value: 30000 },
    { label: "2억", value: 20000 },
    { label: "1억", value: 10000 },
    { label: "5천만", value: 5000 },
    { label: "3천만", value: 3000 },
    { label: "전체", value: 0 },
  ],
};
